export const FontSizeStyle = { fontSize: "16px" };
export const AddSchTitle = "Add Scholarship";
export const SearchPlaceholder = "Search...";
export const SearchWidth = 350;
export const headers = [
  { label: "Scholarship Name", key: "ScholarshipName" },
  { label: "Application URL", key: "ScholarshipApplicationURL" },
  { label: "Scholarship Info URL", key: "ScholarshipURL" },
  { label: "Reward Amount", key: "RewardAmmount" },
  { label: "Student Name", key: "Student" },
  { label: "Year(s) Award for", key: "AutoRenew" },
  { label: "Application Status", key: "Status" },
  { label: "Application Opens Date", key: "ScholarshipOpen" },
  { label: "Application Deadline", key: "Deadline" },
  { label: "Winner Announcement Date", key: "Announcement" },
  { label: "Won", key: "Won" },
  { label: "GPA Requirement", key: "GPARequirement" },
  { label: "Reminder Date", key: "ReminderDate" },
  { label: "Reapply?", key: "Reapply" },
  { label: "Resume Required?", key: "Resume" },
  { label: "Video Required?", key: "Video" },
  { label: "Transcript Required?", key: "Transcript" },
  { label: "Nomination Required?", key: "Nomination" },
  { label: "Proof of College Acceptance", key: "CollegeAcceptProof" },
  { label: "Award Ceremony", key: "AwardCeremony" },
  { label: "Headshot Required?", key: "Headshot" },
  { label: "Money Sent To", key: "SentTo" },
  { label: "Essays Required?", key: "Essays" },
  { label: "Essay Note", key: "EssayNote" },
  {
    label: "Letter of Recommendation Required?",
    key: "LetterOfRecommendation",
  },
  { label: "Letter of Recommendation Note", key: "LetterOfRecommendationNote" },
  { label: "Description", key: "Description" },
  { label: "Note", key: "Note" },
  { label: "Created", key: "created" },
  { label: "Updated", key: "updated" },
];

export const CsvFileName = "Scholarship_Report.csv";
